import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from 'gsap/SplitText'
import { mapState } from 'pinia';
import { getSmoother } from 'utils/ScrollSmootherInstance.js';
import matchMediaConfig from 'utils/matchMedia.js'

gsap.registerPlugin(ScrollTrigger, SplitText);
gsap.registerEase("easeInOutCubic", [0.42, 0, 0.21, 0.99]);

export default {
	data() {
		return {
			blockTitle: null,
			splitTitle: null,
		}
	},
	methods: {
		animateTitle() {
			if (this.splitTitle) {
				this.splitTitle.revert();
			}
			gsap.set(this.blockTitle, { opacity: 1 });

			this.splitTitle = new SplitText(this.blockTitle, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitTitle.lines, {
				duration: 0.8,
				yPercent: 100,
				opacity: 0,
				stagger: 0.1,
				ease: "easeInOutCubic",
			})
		},
		initAnimations() {
			const mm = gsap.matchMedia()
			mm.add(matchMediaConfig, (context) => {
				const { isDesktop, isMobile } = context.conditions
				context.add(() => {
					const headerHeight = document.querySelector('header').offsetHeight;
					this.blockTitle = document.querySelector('.block-simple' + ' .development__title');
					const smoother = getSmoother();

					gsap.to(".block-simple", {
						opacity: 0,
						scrollTrigger: {
							trigger: ".block-simple",
							start: `top ${headerHeight}`,
							end: "bottom top",
							scrub: true
						}
					});

					if (isDesktop) {
						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вниз
							ScrollTrigger.create({
								trigger: ".block-simple",
								start: `bottom ${headerHeight}px`,
								// start: this.scrollTopPosition,
								markers: false,
								id: "block4-1",
								end: `top ${headerHeight}px`,
								onLeaveBack: () => {
									if (this.getScrollDirection === 'up') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(".block-simple", `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							})
						}

						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вверх
							ScrollTrigger.create({
								trigger: ".block-simple",
								start: "25% bottom",
								id: "block4-2",
								markers: false,
								// start: this.scrollDownPosition,
								end: `top ${headerHeight}px`,
								onEnter: () => {
									if (this.getScrollDirection === 'down') {
										this.animateTitle()
										const smoother = getSmoother();
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(".block-simple", `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							});
						}
					}

					// if (isMobile) {
					// 	//TODO ANIMATION
					// 	if (this.getScrollEnabled && true) {
					// 		// настройки для автоматического скролла блока вверх
					// 		ScrollTrigger.create({
					// 			trigger: ".block-simple",
					// 			start: "25% bottom",
					// 			id: "block4-2",
					// 			markers: false,
					// 			// start: this.scrollDownPosition,
					// 			end: `top ${headerHeight}px`,
					// 			onEnter: () => {
					// 				if (this.getScrollDirection === 'down') {
					// 					this.animateTitle()
					// 					const smoother = getSmoother();
					// 					gsap.to(smoother, {
					// 						scrollTop: Math.min(
					// 							ScrollTrigger.maxScroll(window),
					// 							smoother.offset(".block-simple", `top ${headerHeight}px`)
					// 						),
					// 						duration: 1.2,
					// 						ease: "smoother",
					// 						onStart: () => {
					// 							smoother.smooth(0.1);
					// 							smoother.paused(true)
					// 						},
					// 						onComplete: () => {
					// 							smoother.paused(false)
					// 							smoother.smooth(3);
					// 						}
					// 					});
					// 				}
					// 			},
					// 		});
					// 	}
					// }
				})
			})
		},
		killAnimations() {
			ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		}
	},
	computed: {
		...mapState(useViewportStore, ["getIsMobileState"]),
		...mapState(usePageAnimationStore, ["getPageCanAnimateBlocks", "getScrollDirection"]),
		...mapState(useScrollStore, ["getScrollEnabled", "scrollUpPosition", "scrollDownPosition"]),
	},
	mounted() {
		this.$nextTick(() => {
			if (this.getPageCanAnimateBlocks) {
				this.initAnimations();
			}
		});
	},
	beforeUnmount() {
		this.killAnimations();
	},
	watch: {
		getPageCanAnimateBlocks(state) {
			if (state) {
				this.initAnimations();
			}
		},
	}
}
